export default function goToApp({ context, nextMiddleware }){
	if (context.store.getters.isApp){
		return nextMiddleware()
	}
	return context.next({name: 'application', params: context.to.params, query: context.to.query, replace: true})
}
